import { render } from "./CategoryMiddleArticle.vue?vue&type=template&id=7f3e280e"
import script from "./CategoryMiddleArticle.vue?vue&type=script&lang=js"
export * from "./CategoryMiddleArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__